import { Injectable } from '@angular/core';
import { IPaginatorService } from './base';
import { HttpClient } from '@angular/common/http';
import { BasePaginator } from '../model/base/base-model';
import { tap, finalize, share } from 'rxjs/operators';
import { Observable, of, from } from 'rxjs';
import { SyncService } from '@vex/http-service/sync.service';
@Injectable({
  providedIn: 'root'
})

export class CollectionEntryService extends IPaginatorService {

  readonly baseEndpoint = 'CollectionEntry';
  private cache: any = <any>{};
  private cachedObservable: Observable<any> = <Observable<any>>{};

  constructor(private http: HttpClient, private syncService: SyncService) {
    super();
  }

  getPaginatedData<CollectionEntry>(sort: string, order: string, page: number, size: number, filter: string): Observable<BasePaginator<CollectionEntry>> {

    let url = this.baseUrl + this.baseEndpoint + '/GetPaginated/' + page + '/' + size + '?';

    if (sort && order) {
      url += `sort=${sort}&order=${order}`;
    }
    if (filter) {
      url += (sort ? '&' : '') + `filter=${filter}`;
    }

    return this.http.get<BasePaginator<CollectionEntry>>(url);
  }

  getForSelectPaginated(params = {}) {
    return this.http.post<any>(
      this.baseUrl + this.baseEndpoint + '/GetForDependencyDesignerSelectPaginated',
      params || {}
    );
  }

  getForDependencyDesignerByIds(collectionEntryIds: string[]) {
    return this.http.post<any[]>(
      this.baseUrl + this.baseEndpoint + '/GetForDependencyDesignerByIds',
      collectionEntryIds || []
    );
  }

  getAttributesForSelectByCollectionEntry(collectionEntryId: string): Observable<any[]> {
    return this.http.get<any[]>(
      this.baseUrl + this.baseEndpoint + '/GetAttributesForSelectByCollectionEntry/' + collectionEntryId
    );
  }

  getCollectionEntryById(id: string): Observable<any> {
    return this.http.get<any>(this.baseUrl + this.baseEndpoint + '/GetById/' + id);
  }

  getByIds(collectionEntryIds: any[]): Observable<any[]> {
    return from(
      this.syncService.checkAndSyncData('CollectionEntry','CollectionEntry').then(async () => {
        let collectionEntries = await this.syncService.sync('CollectionEntry');
        let data = this.getCollectionEntryByIds(collectionEntryIds, collectionEntries)
        return data;
      })
    );
  }

  getCollectionEntryByIds(collectionEntryIds, collectionEntries) {
    const result = [];
    for (const collectionEntryId of collectionEntryIds) {
      let collection = collectionEntries.find(x=> x.Id == collectionEntryId);
      if(collection) {
        result.push(collection);
      }
    }
    return result;
  }

  getCollectionEntryByCollectionId(collectionId: string) {
    let promise = (async ()=>{
      await this.syncService.checkAndSyncData('CollectionEntry', 'CollectionEntry');
      let allCollectionEntries = await this.syncService.sync('CollectionEntry');
      let resources = allCollectionEntries.filter(x=> x.CollectionId == collectionId);
      return resources;
    })();
    return from(promise);
  }

  getCollectionForSelectByCollectionId(collectionId: string) {
    return this.http.get(this.baseUrl + this.baseEndpoint + '/GetByCollectionForSelect/' + collectionId);
  }

  GetByCollectionForSelect() {
    return this.http.get(this.baseUrl + this.baseEndpoint + '/GetByCollectionForSelect');
  }

  getResourceNamesForSelect() {
    return this.http.get<any[]>(this.baseUrl + this.baseEndpoint + '/GetResourceNamesForSelect');
  }

  getFileByPath(path: string) {
    return this.http.get(this.baseUrl + this.baseEndpoint + '/GetFile/' + path);
  }

  getFeatureDetails(features) {
    return this.http.post(this.baseUrl + 'MigrationClone/GetFeatureDetails', features);
  }

  GetAttributeData(id): Observable<any[]> {
    return from(
      this.syncService.checkAndSyncData('AttributeData', 'AttributeData').then(async () => {
        let data = await this.syncService.sync('AttributeData');
        let values = data?.filter(x=>x.AttributeId === id);
        let latestValue: any[] = [];
        if(values.length > 1) {
          let latestRecord = values.reduce((latestSoFar, current) => {
            let latestDate =
              new Date(latestSoFar.UpdatedDate || latestSoFar.CreatedDate || 0);
            let currentDate =
              new Date(current.UpdatedDate || current.CreatedDate || 0);

            return currentDate > latestDate ? current : latestSoFar;
          });
          latestValue = latestRecord.Values;
        } else if(values.length == 1) {
          latestValue = values[0].Values;
        }
        
        return latestValue;
      })
    )
  }

  getCollectionAttributesByCollectionId(collectionId: string) {
    let observable: Observable<any>;
    if (this.cache['GetCollectionAttributesByCollectionId'+collectionId]) {
      observable = of(this.cache['GetCollectionAttributesByCollectionId'+collectionId]);
    }  else if (this.cachedObservable['GetCollectionAttributesByCollectionId'+collectionId]) {
      observable = this.cachedObservable['GetCollectionAttributesByCollectionId'+collectionId];
    } else {
      this.cachedObservable['GetCollectionAttributesByCollectionId'+collectionId] = this.http.get<any[]>(this.baseUrl + this.baseEndpoint + '/GetCollectionAttributesByCollectionId/' + collectionId)
        .pipe(
          tap(res => this.cache['GetCollectionAttributesByCollectionId'+collectionId] = res),
          share(),
          finalize(() => this.cachedObservable['GetCollectionAttributesByCollectionId'+collectionId] = null)
        );
      observable = this.cachedObservable['GetCollectionAttributesByCollectionId'+collectionId];
    }
    return observable;
  }

 getCollectionForSelect() {
    let promise = (async ()=>{
        await this.syncService.checkAndSyncData('DependencyMap', 'DependencyMap');
        await this.syncService.checkAndSyncData('CollectionEntry', 'CollectionEntry');
       
        let dependencyMaps = await this.syncService.sync('DependencyMap');
        let allCollectionEntries = await this.syncService.sync('CollectionEntry');
        let resources: any[] = [];
          for(let i = 0; i < dependencyMaps.length; i++) {
                let dependencyMap = dependencyMaps[i];
                let collectionEntryIds = this.getCollectionEntryIds(dependencyMap.CollectionDependencies);
                let collectionEntries = allCollectionEntries.filter(x =>
                    collectionEntryIds.includes(x.Id)
                );
                for(let j = 0; j < collectionEntries.length; j++) {
                    let collectionEntry= collectionEntries[j];
                    resources.push({
                        Value: collectionEntry.Id,
                        CollectionId: collectionEntry.CollectionId,
                        Label: collectionEntry.CollectionAttributeValues.find(x=> x.Name == 'Name')?.Value,
                        DependencyMapId: dependencyMap.Id,
                        Description: collectionEntry.CollectionAttributeValues.find(x=> x.Name == 'Description')?.Value,
                        Image: collectionEntry.CollectionAttributeValues.find(x=> x.Name == 'Image')?.Value,
                        DependencyMapName: dependencyMap.Name
                    });
                }
            }
        return resources;
      })();
      return from(promise)
  }
 
  getCollectionEntryIds(dependencyMapCollectionDependencies) {
    const result = [];
 
    for (const dependency of dependencyMapCollectionDependencies) {
        if (dependency.CollectionEntryId && dependency.CollectionEntryId.trim() !== "") {
        result.push(dependency.CollectionEntryId);
        }
 
        if (dependency.ChildCollections && dependency.ChildCollections.length > 0) {
        result.push(...this.getCollectionEntryIds(dependency.ChildCollections));
        }
    }
 
    return result;
  } 

  getAllCollectionEntries(): Observable<any> {
    return from(
      this.syncService.checkAndSyncData('CollectionEntry','CollectionEntry').then(async () => {
        let data = await this.syncService.sync('CollectionEntry');
        return data;
      })
    )
  }
}
